export const DATA_GAPS_PREFERENCE = "data-gaps-preference";
export const DATA_GAPS_PREFERENCE_CHART = "data-gaps-preference-chart";
export const DATA_GAPS_PREFERENCE_TABLE = "data-gaps-preference-table";
